/**
 * Safely extracts a string slug from a value that might be a Sanity slug object or a string.
 */
function extractSlug(value) {
    if (!value) return null;
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && value.current && typeof value.current === 'string') return value.current;
    return null;
}

/**
 * Normalizes a slug by replacing Cyrillic lookalike characters with Latin equivalents.
 * Fixes data entry issues where Cyrillic 'с','а','е','о','р','х' get mixed into Latin slugs.
 */
function normalizeSlug(slug) {
    if (!slug || typeof slug !== 'string') return slug;
    // Cyrillic → Latin lookalike mapping (lowercase only, slugs are always lowercase)
    return slug
        .replace(/\u0441/g, 'c') // с → c
        .replace(/\u0430/g, 'a') // а → a
        .replace(/\u0435/g, 'e') // е → e
        .replace(/\u043e/g, 'o') // о → o
        .replace(/\u0440/g, 'r') // р → r (Cyrillic er)
        .replace(/\u0445/g, 'h') // х → h
        .replace(/\u0443/g, 'u') // у → u
        .replace(/\u043a/g, 'k') // к → k
        .replace(/\u0442/g, 't') // т → t
        .replace(/\u043d/g, 'n') // н → n (Cyrillic en)
        .replace(/\u0456/g, 'i'); // і → i (Ukrainian i)
}

export function buildPoiUrl(lang, countrySlug, citySlug, poiSlug) {
    // Safely extract string values in case objects are passed
    const country = normalizeSlug(extractSlug(countrySlug) || countrySlug);
    const city = normalizeSlug(extractSlug(citySlug) || citySlug);
    const poi = normalizeSlug(extractSlug(poiSlug) || poiSlug);

    if (!lang || !country || !city || !poi) return null;
    if (typeof country !== 'string' || typeof city !== 'string' || typeof poi !== 'string') return null;
    if (country === 'null' || city === 'null' || poi === 'null') return null;
    if (country === 'undefined' || city === 'undefined' || poi === 'undefined') return null;

    return `/${lang}/${country}/${city}/places/${poi}`;
}


